<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="p-dialog feedback-dialog"
    :title="$translate('problemDescription')"
    :visible.sync="dialogVisible"
  >
    <el-input
      v-if="ActiveXObject"
      type="textarea"
      rows="16"
      :placeholder="$translate('pleaseEnterContent')"
      v-model="content"
    >
    </el-input>
    <quill-editor
      v-else
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
    >
    </quill-editor>
    <div slot="footer" class="dialog-footer text-center">
      <el-button
        class="p-button"
        size="small"
        type="primary"
        :disabled="isSubmiting"
        @click="submit"
      >
        {{ $translate("sure") }}
      </el-button>
      <el-button
        class="p-button cancel_btn"
        size="small"
        @click="dialogVisible = false"
      >
        {{ $translate("cancel") }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
export default {
  components: { quillEditor },
  data() {
    return {
      ActiveXObject: window.ActiveXObject,
      dialogVisible: false,
      content: "",
      editorOption: {
        placeholder: this.$translate("pleaseEnterContent"),
      },
      isSubmiting: false,
    };
  },
  methods: {
    // 编辑区失焦
    onEditorBlur(quill) {
      let ele = quill.container;
      ele.style.backgroundColor = "";
    },
    // 编辑获取焦点
    onEditorFocus(quill) {
      let ele = quill.container;
      ele.style.backgroundColor = "#fff";
    },
    submit() {
      if (this.content.length == 0) {
        this.$message({
          message: this.$translate("pleaseEnterContent"),
          showClose: true,
          type: "warning",
        });
      } else {
        this.isSubmiting = true;
        this.$api.FeedBack.createMyItem({ content: this.content }).then(
          (res) => {
            if (res && res.isSuccess) {
              this.$message({
                message: this.$translate("feedbackSuccess"),
                showClose: true,
                type: "success",
              });
              this.content = "";
              this.dialogVisible = false;
            }
            this.isSubmiting = false;
          }
        );
      }
    },
  },
};
</script>
<style lang="scss">
.feedback-dialog .ql-editor {
  height: 200px;
}
</style>
